import { registerSW } from "virtual:pwa-register";

// The service worker keeps the app shell for offline use. New releases must reach phones on the
// next open, not two reloads later: the worker takes over at once, the page reloads into the new
// build, and open tabs check for a release every 30 minutes and on return to the app.
const CHECK_EVERY_MS = 30 * 60_000;

export function startPwa() {
  if (!("serviceWorker" in navigator)) return;
  registerSW({
    immediate: true,
    onRegisteredSW(_url, registration) {
      if (!registration) return;
      const check = () => void registration.update().catch(() => undefined);
      setInterval(check, CHECK_EVERY_MS);
      document.addEventListener("visibilitychange", () => document.visibilityState === "visible" && check());
    },
  });
}

/** Settings > "Get latest version": drop the cached shell and load fresh from the server. */
export async function reloadLatest() {
  try {
    const regs = await navigator.serviceWorker?.getRegistrations();
    await Promise.all((regs ?? []).map((r) => r.unregister()));
    const keys = await caches?.keys();
    await Promise.all((keys ?? []).map((k) => caches.delete(k)));
  } finally {
    window.location.reload();
  }
}

